import {connect} from 'react-redux';
import App from '../../components/App/App';
import {IReduxStoreState} from '../../@interfaces';
import {appBootstrap, appLoadRequires} from '../../_redux/app/actions';

const AppMapStateToProps = (state: IReduxStoreState) => ({
    ...state.app,
    user: state.user,
    locale: state.locale.locale,
});

const AppMapDispatchToProps = {
    appBootstrap,
    appLoadRequires,
};

export default connect(AppMapStateToProps, AppMapDispatchToProps)(App);
